import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatDuration, getCategoryName } from "@/utils/video";

export default function SidebarList({ items }: { items: Video[] }) {
  if (items.length === 0) {
    return (
      <p className="px-4 py-8 text-center text-xs text-foreground-500">
        该分类暂无更多片目。
      </p>
    );
  }

  return (
    <ul>
      {items.map((video) => (
        <li key={video.id}>
          <Link
            to={`/detail/${video.id}`}
            className="group flex items-center gap-3 border-b border-background-800/70 px-4 py-3 last:border-b-0 hover:bg-background-800/50"
          >
            <div className="relative h-[52px] w-[92px] shrink-0 overflow-hidden rounded bg-background-800">
              <img
                src={video.cover}
                alt={`${video.title} 封面`}
                title={`${video.title} - 相关推荐`}
                className="h-full w-full object-cover object-top"
              />
              <span className="absolute bottom-1 right-1 rounded bg-background-950/80 px-1 text-[10px] tabular-nums text-foreground-100">
                {formatDuration(video.duration)}
              </span>
            </div>
            <div className="min-w-0">
              <p className="truncate text-xs font-medium text-foreground-100 transition-colors group-hover:text-primary-200">
                {video.title}
              </p>
              <p className="mt-1 truncate text-[11px] text-foreground-500">
                {getCategoryName(video.category)} · {video.type}
              </p>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}